/* Background gallery preloading.

   The galleries render their first 15 photos normally and everything
   after that with NO src at all — the URLs sit in data-src/data-srcset
   instead (see snippets/tuti-mobile-gallery.liquid). This script hands
   those images their src once the page has loaded, a few at a time.

   Why no src rather than loading="lazy": a lazy image only begins
   fetching when it is scrolled to, so swiping through the gallery hit a
   grey placeholder box while each photo downloaded. A deferred image
   cannot be triggered by scrolling at all — nothing fetches it until
   this script says so — which means the whole run is quietly filled in
   behind the shopper instead of being pulled in under them.

   First paint therefore carries 15 photos, and the remaining ~90 arrive
   in the background without competing for the bandwidth that the
   opening view needs.

   Promotion starts in idle time after `load`, and runs in small chunks
   with a pause between them, so it never competes with anything the
   shopper can see. If they reach a photo before its turn comes up, the
   swipe handler can call window.tutiGalleryPreload.now(img) to jump it
   the queue. */
(function () {
  'use strict';

  /* Images promoted per pass, and the pause between passes. */
  var CHUNK = 4;
  var GAP = 200;
  var SELECTOR = 'img[data-tuti-defer][data-src]';

  /* Give one image its source. Idempotent — the attributes are removed
     as it goes, so it can never be promoted twice. */
  function load(img) {
    if (!img || !img.dataset.src) return;

    var srcset = img.dataset.srcset;
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.dataset.src);

    delete img.dataset.src;
    delete img.dataset.srcset;
    img.removeAttribute('data-tuti-defer');
  }

  function promote() {
    var pending = document.querySelectorAll(SELECTOR);
    if (!pending.length) return;

    var n = Math.min(CHUNK, pending.length);
    for (var i = 0; i < n; i++) load(pending[i]);

    setTimeout(promote, GAP);
  }

  function start() {
    if (window.requestIdleCallback) {
      /* The timeout matters: a page that never goes idle would otherwise
         never fill in the rest of the gallery. */
      window.requestIdleCallback(promote, { timeout: 2000 });
    } else {
      setTimeout(promote, 400);
    }
  }

  /* Exposed so the galleries can pull a specific photo forward — if a
     shopper swipes faster than the queue fills, the slide they are
     heading for can be loaded immediately rather than waiting its turn. */
  window.tutiGalleryPreload = {
    now: function (img) {
      if (img && img.matches && img.matches(SELECTOR)) load(img);
    },
    slide: function (el) {
      if (!el) return;
      var img = el.querySelector ? el.querySelector(SELECTOR) : null;
      if (img) load(img);
    },
  };

  /* After `load`, not DOMContentLoaded: the first 15 should have the
     network to themselves until they are done. */
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
